import { ContentPaste } from "@mui/icons-material";
import { Button, IconButton, TableCell, Tooltip } from "@mui/material";
import { useEhrRecordsMobileLayout } from "../../../context/EhrRecordsLayoutContext";
import {
  EhrMobileActionStack,
  ehrMobileActionBtnSx,
} from "../../mobile/EhrMobileActionStack";

export function QuestionnairesActions({
  row,
  onOpenSelected,
}: {
  row: any;
  onOpenSelected: (row: any) => void;
}) {
  const isEhrMobileCard = useEhrRecordsMobileLayout();

  if (isEhrMobileCard) {
    return (
      <EhrMobileActionStack>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<ContentPaste />}
          sx={ehrMobileActionBtnSx}
          onClick={() => {
            onOpenSelected(row);
          }}
        >
          Visualizar respostas
        </Button>
      </EhrMobileActionStack>
    );
  }

  return (
    <TableCell align="center">
      <Tooltip title="Visualizar respostas">
        <IconButton
          onClick={() => {
            onOpenSelected(row);
          }}
        >
          <ContentPaste />
        </IconButton>
      </Tooltip>
    </TableCell>
  );
}
